const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

/**
 * GET /api/leaderboard on pow-api. Public route — no token required.
 *
 * `limit` caps the response server-side, so "top 15" means the top 15 of the
 * sorted list rather than 15 rows of a longer one trimmed in the browser.
 */
export async function getLeaderboard({ limit, sortBy, sortDir, signal } = {}) {
  const params = new URLSearchParams();
  if (limit != null) params.set('limit', limit);
  if (sortBy) {
    params.set('sortBy', sortBy);
    params.set('sortDir', sortDir || 'desc');
  }

  const query = params.toString();
  const response = await fetch(`${baseURL}/leaderboard${query ? `?${query}` : ''}`, { signal });

  if (!response.ok) {
    throw new Error(`Could not load the leaderboard (${response.status}).`);
  }

  return response.json();
}
